const config = {
  apiBaseUrl: 'https://ob8veqngf7.execute-api.eu-west-1.amazonaws.com/prod',
  defaultLandingPage: 'login',
  locationByHost: {
    'cuikbook.gavinpotter.co.uk': 'penicuik',
  },
  titleByHost: {
    'dollysdirectory.info': "Dolly's Directory",
  },
  auth: {
    region: 'eu-west-1',
    clientId: '7o9n5f8n6ashotji1ojkpj9ri6',
    flow: 'USER_PASSWORD_AUTH',
  },
  featuresByLocation: {
    penicuik: {
      enableMMP: true,
      enableDarkMode: true,
    },
    loanhead: {
      enableMMP: false,
      enableDarkMode: false,
    },
    roslin: {
      enableMMP: false,
      enableDarkMode: false,
    },
  },
  branding: {
    logos: ['practice_logo.png'],
    logosByLocation: {
      loanhead: ['practice_logo_loanhead.png'],
      penicuik: ['practice_logo_penicuik.png'],
      roslin: ['practice_logo_roslin.png'],
    },
    logoCentred: {
      loanhead: false,
      penicuik: false,
      roslin: true,
    },
  },
};

export { config };
